export const FILE_SIZE = 5 * 1024 * 1024; // 5 Mb
export const SUPPORTED_FORMATS = [
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export const SUPPORTED_TYPES = [ '.csv', '.xlsx', '.xls' ];
